export const columnOptions = [
  {
    field: "N de client",
    description: "Identifiant unique pour le client",
    example: "CLI001, CLI002",
    required: true,
    category: "basic",
  },
  {
    field: "Nom",
    description: "Nom du client ou de la société",
    example: "ACME Corp, John Doe",
    required: true,
    category: "basic",
  },
  {
    field: "Siret",
    description: "Numéro SIRET",
    example: "123456789 01234",
    required: false,
    category: "basic",
  },
  {
    field: "Siren",
    description: "Numéro SIREN",
    example: "12345678900000",
    required: false,
    category: "basic",
  },
  {
    field: "Type de client",
    description: "Type de client - utiliser les codes exacts affichés",
    options: [
      { code: "en", label: 'Entreprise - "en"' },
      { code: "pa", label: 'Particulier - "pa"' },
      { code: "pu", label: 'administration publique - "pu"' },
      { code: "so", label: 'Société - "so"' },
    ],
    example: "en, pa, pu, so",
    required: true,
    category: "classification",
  },
  {
    field: "Type TVA client",
    description: "Catégorie de TVA pour le client - utiliser les codes exacts affichés",
    options: [
      { code: "LOC", label: 'Clients Local - "LOC"' },
      { code: "IN", label: 'Clients Europe - "IN"' },
      { code: "EX", label: 'Clients Exonérés - "EX"' },
      { code: "DOM", label: 'Clients Dom Tom - "DOM"' },
      { code: "CORS", label: 'Clients Corse - "CORS"' },
    ],
    example: "LOC, IN, EX, DOM, CORS",
    required: true,
    category: "classification",
  },
  {
    field: "Forme juridique",
    description: "Structure juridique de la société - utiliser les codes exacts affichés",
    options: [
      { code: "ASS", label: 'Association - "ASS"' },
      { code: "CAB", label: 'Cabinet - "CAB"' },
      { code: "CE", label: 'Comité d\'entreprise - "CE"' },
      { code: "CIE", label: 'Compagnie - "CIE"' },
      { code: "CL", label: 'Collectivité locale - "CL"' },
      { code: "CMA", label: 'Coopérative d\'utilisation de matériel agricole - "CMA"' },
      { code: "COL", label: 'Entreprise Collective - "COL"' },
      { code: "COM", label: 'Commune - "COM"' },
      { code: "COP", label: 'Coopérative - "COP"' },
      { code: "EARL", label: 'Entreprise agricole à responsabilité limitée - "EARL"' },
      { code: "EI", label: 'Entreprise individuelle - "EI"' },
      { code: "EIR", label: 'Entreprise individuelle à responsabilité limitée - "EIR"' },
      { code: "ENT", label: 'Entreprise - "ENT"' },
      { code: "ETS", label: 'Etablissements - "ETS"' },
      { code: "EURL", label: 'Entreprise unipersonnelle à responsabilité limitée - "EURL"' },
      { code: "FED", label: 'Fédération - "FED"' },
      { code: "GAEC", label: 'Groupement agricole d\'exploitation en commun - "GAEC"' },
      { code: "GAF", label: 'Groupement agricole foncier - "GAF"' },
      { code: "GEI", label: 'Groupement européen d\'intérêt économique - "GEI"' },
      { code: "GF", label: 'Groupement forestier - "GF"' },
      { code: "GFA", label: 'Groupement foncier agricole - "GFA"' },
      { code: "GFR", label: 'Groupement foncier rural - "GFR"' },
      { code: "GIE", label: 'Groupement d\'intérêt économique - "GIE"' },
      { code: "GPT", label: 'Groupement - "GPT"' },
      { code: "GRF", label: 'Greffe - "GRF"' },
      { code: "IND", label: 'Société indépendante - "IND"' },
      { code: "M", label: 'Monsieur - "M"' },
      { code: "ME", label: 'Maître - "ME"' },
      { code: "MLE", label: 'Mademoiselle - "MLE"' },
      { code: "MME", label: 'Madame - "MME"' },
      { code: "MUT", label: 'Mutuelle - "MUT"' },
      { code: "SA", label: 'Société anonyme - "SA"' },
      { code: "SAE", label: 'Société anomyme d\'exploitation - "SAE"' },
      { code: "SAG", label: 'Syndicat agricole - "SAG"' },
      { code: "SARL", label: 'Société à responsabilité limitée - "SARL"' },
      { code: "SARLU", label: 'SARL au Luxembourg - "SARLU"' },
      { code: "SAS", label: 'Société par actions simplifiée - "SAS"' },
      { code: "SC", label: 'Société civile autre que SCM - "SC"' },
      { code: "SCA", label: 'Société en commandite par actions - "SCA"' },
      { code: "SCE", label: 'Société civile d\'exploitation - "SCE"' },
      { code: "SCEA", label: 'Société civile d\'exploitation agricole - "SCEA"' },
      { code: "SCEV", label: 'Société civile d\'exploitation vinicole - "SCEV"' },
      { code: "SCH", label: 'Société civile holding - "SCH"' },
      { code: "SCI", label: 'Société civile immobilière - "SCI"' },
      { code: "SCM", label: 'Société civile de moyens - "SCM"' },
      { code: "SCP", label: 'Société civile professionnelle - "SCP"' },
      { code: "SCPI", label: 'Société civile de placement immobilier - "SCPI"' },
      { code: "SCS", label: 'Société en commandite simple - "SCS"' },
      { code: "SCV", label: 'Société civile de construction vente - "SCV"' },
      { code: "SDE", label: 'Société de droit étranger - "SDE"' },
      { code: "SEL", label: 'Société d\'exploitation libérale à forme anonyme - "SEL"' },
      { code: "SEM", label: 'Société d\'économie mixte - "SEM"' },
      { code: "SIC", label: 'Société d\'intérêt collectif agricole - "SIC"' },
      { code: "SIG", label: 'Société immobilière de gestion - "SIG"' },
      { code: "SII", label: 'Société immobilière d\'investissement - "SII"' },
      { code: "SLCA", label: 'Sté d\'exercice libéral en commandite par actions - "SLCA"' },
      { code: "SLFA", label: 'Société d\'exercice libéral à forme anonyme - "SLFA"' },
      { code: "SLU", label: 'Sté d\'exploit libérale uni personne à resp limitée - "SLU"' },
      { code: "SMI", label: 'Société mixte d\'intérêt agricole - "SMI"' },
      { code: "SNC", label: 'Société en nom collectif - "SNC"' },
      { code: "SPG", label: 'Société civile participation gestion - "SPG"' },
      { code: "SPL", label: 'Société en participation de professions libérales - "SPL"' },
      { code: "SRLR", label: 'Sté d\'exercice libéral à responsabilité limitée - "SRLR"' },
      { code: "STE", label: 'Société - "STE"' },
      { code: "STEF", label: 'Société de fait - "STEF"' },
      { code: "STEP", label: 'Société en participation - "STEP"' },
      { code: "STP", label: 'Société civile de vente volontaire - "STP"' },
      { code: "TOM", label: 'Territoire d\'Outre-Mer - "TOM"' },
      { code: "ZZZ", label: 'Autres - "ZZZ"' },
    ],
    example: "SARL, SAS, SA, EURL",
    required: false,
    category: "classification",
  },
  {
    field: "Devise",
    description:
      "Code de devise pour les transactions (doit exister dans la table des devises). Si la devise n'est pas fournie ou incorrecte, la devise par défaut sera utilisée",
    example: "EUR, USD, GBP",
    required: false,
    category: "financial",
  },
  {
    field: "Compte",
    description:
      "Numéro de compte comptable du client (plan comptable général). Code comptable utilisé pour l'enregistrement des opérations",
    example: "411000, 411001, 411CLIXX",
    required: false,
    category: "financial",
  },
  {
    field: "Adresse",
    description: "Adresse",
    example: "123 Rue de la Paix",
    required: true,
    category: "address",
  },
  {
    field: "Numéro",
    description: "Numéro",
    example: "6, 12, 14",
    required: false,
    category: "number",
  },
  {
    field: "BTQ",
    description: "Bis, Ter, Quater",
    example: "B, T, Q",
    required: false,
    category: "address",
  },
  {
    field: "Pays",
    description: "Code du pays",
    example: "FR, BE, DE, IT, ES, PT, NL",
    required: true,
    category: "address",
    options: [
      { code: "DE", label: "Allemagne" },
      { code: "AD", label: "Andorre" },
      { code: "AO", label: "Angola" },
      { code: "AI", label: "Anguilla" },
      { code: "AQ", label: "Antarctique" },
      { code: "AN", label: "Antilles néerlandaises" },
      { code: "AG", label: "Antigua-Et-Barbuda" },
      { code: "SA", label: "Arabie Saoudite" },
      { code: "AR", label: "Argentine" },
      { code: "AM", label: "Arménie" },
      { code: "AW", label: "Aruba" },
      { code: "AU", label: "Australie" },
      { code: "AT", label: "Autriche" },
      { code: "AZ", label: "Azerbaïdjan" },
      { code: "BS", label: "Bahamas" },
      { code: "BH", label: "Bahreïn" },
      { code: "BD", label: "Bangladesh" },
      { code: "BB", label: "Barbad" },
      { code: "BE", label: "Belgique" },
      { code: "BZ", label: "Belize" },
      { code: "BJ", label: "Bénin" },
      { code: "BM", label: "Bermudes" },
      { code: "BT", label: "Bhoutan" },
      { code: "BY", label: "Biélorussie" },
      { code: "MM", label: "Birmanie" },
      { code: "BO", label: "État Plurinational De Bolivie" },
      { code: "BA", label: "Bosnie-Herzégovine" },
      { code: "BW", label: "Botswana" },
      { code: "BR", label: "Brésil" },
      { code: "BN", label: "Brunei Darussalam" },
      { code: "BG", label: "Bulgarie" },
      { code: "BF", label: "Burkina Faso" },
      { code: "BI", label: "Burundi" },
      { code: "KH", label: "Cambodge" },
      { code: "CM", label: "Cameroun" },
      { code: "CA", label: "Canada" },
      { code: "CV", label: "Cap-Vert" },
      { code: "CL", label: "Chili" },
      { code: "CN", label: "Chine" },
      { code: "CY", label: "Chypre" },
      { code: "CO", label: "Colombie" },
      { code: "KM", label: "Comores" },
      { code: "CG", label: "Congo" },
      { code: "KR", label: "République De Corée" },
      { code: "CR", label: "Costa Rica" },
      { code: "CI", label: "Côte D'Ivoire" },
      { code: "HR", label: "Croatie" },
      { code: "CU", label: "Cuba" },
      { code: "DK", label: "Denmark" },
      { code: "DJ", label: "Djibouti" },
      { code: "DM", label: "Dominique" },
      { code: "EG", label: "Égypte" },
      { code: "AE", label: "Émirats Arabes Unis" },
      { code: "EC", label: "Équateur" },
      { code: "ER", label: "Érythrée" },
      { code: "ES", label: "Espagne" },
      { code: "EE", label: "Estonie" },
      { code: "US", label: "États-Unis" },
      { code: "FM", label: "États Fédérés De Micronésie" },
      { code: "ET", label: "Éthiopie" },
      { code: "FJ", label: "Fidji" },
      { code: "FI", label: "Finlande" },
      { code: "FR", label: "France" },
      { code: "GA", label: "Gabon" },
      { code: "GM", label: "Gambie" },
      { code: "GE", label: "Géorgie" },
      { code: "GS", label: "Géorgie Du Sud-Et-Les Îles Sandwich Du Sud" },
      { code: "GH", label: "Ghana" },
      { code: "GI", label: "Gibraltar" },
      { code: "GR", label: "Grèce" },
      { code: "GD", label: "Grenade" },
      { code: "GL", label: "Groenland" },
      { code: "GP", label: "Guadeloupe" },
      { code: "GU", label: "Guam" },
      { code: "GT", label: "Guatemala" },
      { code: "GG", label: "Guernesey" },
      { code: "GN", label: "Guinée" },
      { code: "GQ", label: "Guinée Équatoriale" },
      { code: "GW", label: "Guinée-Bissau" },
      { code: "GY", label: "Guyana" },
      { code: "GF", label: "Guyane" },
      { code: "HT", label: "Haïti" },
      { code: "HN", label: "Honduras" },
      { code: "HK", label: "Hong Kong" },
      { code: "HU", label: "Hongrie" },
      { code: "BV", label: "Île Bouvet" },
      { code: "CX", label: "Île Christmas" },
      { code: "IM", label: "Île De Man" },
      { code: "NF", label: "Île Norfolk" },
      { code: "AX", label: "Îles Åland" },
      { code: "KY", label: "Îles Caïmans" },
      { code: "CC", label: "Îles Cocos" },
      { code: "CK", label: "Îles Cook" },
      { code: "FO", label: "Îles Féroé" },
      { code: "HM", label: "Îles Heard-Et-MacDonald" },
      { code: "FK", label: "Îles Malouines" },
      { code: "MP", label: "Îles Mariannes Du Nord" },
      { code: "MH", label: "Îles Marshall" },
      { code: "UM", label: "Îles Mineures Éloignées Des États-Unis" },
      { code: "SB", label: "Îles Salomon" },
      { code: "TC", label: "Îles Turks-Et-Caïcos" },
      { code: "VG", label: "Îles Vierges Britanniques" },
      { code: "VI", label: "Îles Vierges Des États-Unis" },
      { code: "IN", label: "Inde" },
      { code: "ID", label: "Indonésie" },
      { code: "IQ", label: "Irak" },
      { code: "IR", label: "République Islamique D'Iran" },
      { code: "IE", label: "Irlande" },
      { code: "IS", label: "Islande" },
      { code: "IL", label: "Israël" },
      { code: "IT", label: "Italie" },
      { code: "JM", label: "Jamaïque" },
      { code: "JP", label: "Japon" },
      { code: "JE", label: "Jersey" },
      { code: "JO", label: "Jordanie" },
      { code: "KZ", label: "Kazakhstan" },
      { code: "KE", label: "Kenya" },
      { code: "KG", label: "Kirghizistan" },
      { code: "KI", label: "Kiribati" },
      { code: "KW", label: "Koweït" },
      { code: "LS", label: "Lesotho" },
      { code: "LV", label: "Lettonie" },
      { code: "LB", label: "Liban" },
      { code: "LR", label: "Liberia" },
      { code: "LY", label: "Libye" },
      { code: "LI", label: "Liechtenstein" },
      { code: "LT", label: "Lituanie" },
      { code: "LU", label: "Luxembourg" },
      { code: "MO", label: "Macao" },
      { code: "MK", label: "Macédoine" },
      { code: "MG", label: "Madagascar" },
      { code: "MY", label: "Malaisie" },
      { code: "MW", label: "Malawi" },
      { code: "MV", label: "Maldives" },
      { code: "ML", label: "Mali" },
      { code: "MT", label: "Malte" },
      { code: "MA", label: "Maroc" },
      { code: "MQ", label: "Martinique" },
      { code: "MU", label: "Maurice" },
      { code: "MR", label: "Mauritanie" },
      { code: "YT", label: "Mayotte" },
      { code: "MX", label: "Mexique" },
      { code: "MD", label: "République De Moldavie" },
      { code: "MC", label: "Monaco" },
      { code: "MN", label: "Mongolie" },
      { code: "MS", label: "Montserrat" },
      { code: "MZ", label: "Mozambique" },
      { code: "NA", label: "Namibie" },
      { code: "NR", label: "Nauru" },
      { code: "NP", label: "Népal" },
      { code: "NI", label: "Nicaragua" },
      { code: "NE", label: "Niger" },
      { code: "NG", label: "Nigéria" },
      { code: "NU", label: "Niue" },
      { code: "NO", label: "Norvège" },
      { code: "NC", label: "Nouvelle-Calédonie" },
      { code: "NZ", label: "Nouvelle-Zélande" },
      { code: "OM", label: "Oman" },
      { code: "UG", label: "Ouganda" },
      { code: "UZ", label: "Ouzbékistan" },
      { code: "PK", label: "Pakistan" },
      { code: "PW", label: "Palaos" },
      { code: "PA", label: "Panama" },
      { code: "PG", label: "Papouasie-Nouvelle-Guinée" },
      { code: "PY", label: "Paraguay" },
      { code: "NL", label: "Pays-Bas" },
      { code: "PE", label: "Pérou" },
      { code: "PH", label: "Philippines" },
      { code: "PN", label: "Pitcairn" },
      { code: "PL", label: "Pologne" },
      { code: "PF", label: "Polynésie Française" },
      { code: "PR", label: "Porto Rico" },
      { code: "PT", label: "Portugal" },
      { code: "QA", label: "Qatar" },
      { code: "CF", label: "République Centrafricaine" },
      { code: "CD", label: "République Démocratique Du Congo" },
      { code: "LA", label: "République Démocratique Populaire Lao" },
      { code: "DO", label: "République Dominicaine" },
      { code: "SV", label: "République Du Salvador" },
      { code: "KP", label: "République Populaire Démocratique De Corée" },
      { code: "CZ", label: "République Tchèque" },
      { code: "TZ", label: "République-Unie De Tanzanie" },
      { code: "SY", label: "République Arabe Syrienne" },
      { code: "RE", label: "Réunion" },
      { code: "RO", label: "Roumanie" },
      { code: "GB", label: "Royaume-Uni" },
      { code: "RU", label: "Fédération De Russie" },
      { code: "RW", label: "Rwanda" },
      { code: "EH", label: "Sahara Occidental" },
      { code: "KN", label: "Saint-Christophe-et-Niévès" },
      { code: "SH", label: "Sainte-Hélène" },
      { code: "LC", label: "Sainte-Lucie" },
      { code: "SM", label: "Saint-Marin" },
      { code: "PM", label: "Saint-Pierre-Et-Miquelon" },
      { code: "VA", label: "Saint-Siège (État De La Cité Du Vatican)" },
      { code: "VC", label: "Saint-Vincent-Et-Les Grenadines" },
      { code: "WS", label: "Samoa" },
      { code: "AS", label: "Samoa Américaines" },
      { code: "ST", label: "Sao Tomé-Et-Principe" },
      { code: "SN", label: "Sénégal" },
      { code: "CS", label: "Serbie-et-Monténégro" },
      { code: "SC", label: "Seychelles" },
      { code: "SL", label: "Sierra Leone" },
      { code: "SG", label: "Singapour" },
      { code: "SK", label: "Slovaquie" },
      { code: "SI", label: "Slovénie" },
      { code: "SO", label: "Somalie" },
      { code: "SD", label: "Soudan" },
      { code: "LK", label: "Sri Lanka" },
      { code: "ZA", label: "Afrique Du Sud" },
      { code: "SE", label: "Suède" },
      { code: "CH", label: "Suisse" },
      { code: "SR", label: "Suriname" },
      { code: "SJ", label: "Svalbard Et Jan Mayen" },
      { code: "SZ", label: "Swaziland" },
      { code: "TW", label: "Taïwan" },
      { code: "TJ", label: "Tadjikistan" },
      { code: "TD", label: "Tchad" },
      { code: "TF", label: "Terres Australes Françaises" },
      { code: "IO", label: "Territoire Britannique De L'océan Indien" },
      { code: "PS", label: "Territoires Palestiniens Occupés" },
      { code: "TH", label: "Thaïlande" },
      { code: "TL", label: "Timor-Leste" },
      { code: "TG", label: "Togo" },
      { code: "TK", label: "Tokelau" },
      { code: "TO", label: "Tonga" },
      { code: "TT", label: "Trinité-Et-Tobago" },
      { code: "TN", label: "Tunisie" },
      { code: "TM", label: "Turkménistan" },
      { code: "TR", label: "Turquie" },
      { code: "TV", label: "Tuvalu" },
      { code: "UA", label: "Ukraine" },
      { code: "UY", label: "Uruguay" },
      { code: "VU", label: "Vanuatu" },
      { code: "VE", label: "Venezuela" },
      { code: "VN", label: "Viet Nam" },
      { code: "WF", label: "Wallis Et Futuna" },
      { code: "YE", label: "Yémen" },
      { code: "ZM", label: "Zambie" },
      { code: "ZW", label: "Zimbabwe" },
    ],
  },
  {
    field: "Code Postal",
    description: "Code postal",
    example: "75001, 69002",
    required: true,
    category: "address",
  },
  {
    field: "Ville",
    description: "Nom de la ville",
    example: "Paris, Lyon, Marseille",
    required: true,
    category: "address",
  },
  {
    field: "Téléphone",
    description: "Téléphone",
    example: "01 23 45 67 89, 06 12 34 56 78, 0612345678, +33 1 23 45 67 89",
    required: false,
    category: "address",
  },
  {
    field: "E-mail",
    description: "E-mail",
    example: "exemple@exemple.fr",
    required: false,
    category: "address",
  },
];
